/* global axios */
import ApiClient from './ApiClient';

class EmailSuppressionsAPI extends ApiClient {
  constructor() {
    super('email_suppressions', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  importCsv(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/import_csv`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new EmailSuppressionsAPI();
